import React, { FunctionComponent, useCallback, useMemo } from 'react';
import StringUtils from '../utils';

export interface Field {
  key: string;
  label?: string;
  render?: (data: unknown) => string;
}

/**
 * ListDetails props
 */
interface Props {
  data: unknown;
  fields: Field[];
}

type Data = Record<string, any>;

/**
 * ListDetails Component
 */
const ListDetails: FunctionComponent<Props> = ({ data: cData, fields }) => {
  const data = useMemo<Data>(() => cData as Data, [cData]);
  const renderItems = useCallback(
    () =>
      fields.map(field => (
        <tr key={field.key}>
          <td>
            <span className="text-base text-[#888888]">
              {field.label || StringUtils.prettify(field.key)}
            </span>
          </td>
          <td style={{ textAlign: 'right' }}>
            <span className="text-base text-black">
              {field.render ? field.render(data) : (data[field.key] as string)}
            </span>
          </td>
        </tr>
      )),
    [data, fields],
  );

  return (
    <table className="table-list-details w-full">
      <tbody>{renderItems()}</tbody>
    </table>
  );
};

export default ListDetails;
